import React from 'react';
import PropTypes from 'prop-types';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { uniqueId } from 'lodash';

export const ZipCode = ({ required, id, model, label }) => {
  const MAX_LENGTH = 5;

  return (
    <React.Fragment>
      <TextInput
        model={model}
        label={label}
        mask="numeric"
        maxLength={MAX_LENGTH}
        formatter={(value) => {
          return value.replace(
            /[!@#$%^&*)({}<>,.[\]+_`~=\\|';":/?A-Za-z]/g,
            ''
          );
        }}
        validators={{
          required: required ? 'Zip code is required.' : '',
          validate: {
            isValidZip: (value) => {
              return value.length < MAX_LENGTH
                ? 'Please enter a valid zip code'
                : null;
            },
          },
        }}
        isClearable
        data-testid="primary-servicing-address-zipCode"
        name={`${model}-input-${uniqueId()}`}
      />
    </React.Fragment>
  );
};

ZipCode.propTypes = {
  required: PropTypes.bool,
  id: PropTypes.string,
  model: PropTypes.string.isRequired,
  label: PropTypes.string,
};

ZipCode.defaultProps = {
  required: false,
  id: 'address-zipcode-input',
  label: 'Zip Code',
};
